export default function Marquee({ items = ["RIGHT PLACE. RIGHT TIME.", "STAY ALIGNED", "NO COINCIDENCES", "TRUST THE PROCESS"], className = "" }) {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden border-y border-white/10 py-4 ${className}`}>
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="mx-6 font-mono text-xs uppercase tracking-[0.35em] text-fade">
                {t} <span className="ml-6 text-bone/40">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
